export default function LocationLoader () {
    return (
        <div>
            <hr className="text-body-tertiary"/>
            <div className="row">
                <div className="col-6">
                    <span className="placeholder placeholder-wave bg-secondary col-8"></span><br />
                    <span className="placeholder placeholder-wave bg-secondary col-6"></span><br />
                    <span className="placeholder placeholder-wave bg-secondary col-6"></span><br />
                    <span className="placeholder placeholder-wave bg-secondary col-6"></span><br />
                </div>
                <div className="col-6">
                    <span className="placeholder placeholder-wave bg-secondary offset-8 col-4"></span><br />
                    <span className="placeholder placeholder-wave bg-secondary offset-10 col-2"></span><br />
                </div>
                    
            </div>
            
        </div>
    )
}